import clsx from 'clsx';
import { useVimeoVideoContext } from '../../Vimeo';

interface VimeoVideoRuntimePillProps {
  className?: string;
}

export function VimeoVideoRuntimePill({ className }: VimeoVideoRuntimePillProps) {
  const { formattedDuration } = useVimeoVideoContext();

  if (!formattedDuration) return null;

  return (
    <div
      className={clsx('inline-flex items-start gap-[10px] px-2 pt-[2px] pb-[1px] rounded-lg bg-black/60', className)}
    >
      <span className={'text-white text-[11px] font-medium tracking-[0.11px] leading-[13px] text-center'}>
        {formattedDuration}
      </span>
    </div>
  );
}
